import React, { useState, useEffect, useCallback } from 'react'
import { Form, Message } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import { format } from 'date-fns'

import api from '../../services/api'

export default function TicketComments({ id_ticket }) {
  const [comentarios, setComentarios] = useState([])

  const fetchComments = useCallback(async () => {
    try {
      const { data } = await api.get(`/comments/ticket/${id_ticket}`)
      setComentarios(data)
    } catch (error) {
      console.error('Error fetching comments:', error)
      toast.error('Erro ao buscar comentários do ticket')
    }
  }, [id_ticket])

  useEffect(() => {
    fetchComments()
  }, [fetchComments])

  const moverParaFim = useCallback(() => {
    const el = document.getElementById('messageComments')
    if (el) {
      requestAnimationFrame(() => {
        el.scrollTop = el.scrollHeight
      })
    }
  }, [])

  function ajustarAlturaTextAreas() {
    const textareas = document.querySelectorAll('[id^="textAreaComment-"]')
    for (const textarea of textareas) {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    moverParaFim()
    ajustarAlturaTextAreas()
  }, [comentarios, moverParaFim])

  return (
    <Message
      id="messageComments"
      style={{ flex: 1, maxHeight: '900px', overflowY: 'auto' }}
    >
      {comentarios.length === 0 && (
        <Message.Header style={{ textAlign: 'center', paddingTop: '20px' }}>
          Nenhum comentário encontrado para este ticket.
        </Message.Header>
      )}
      {comentarios?.map((comentario) => {
        return (
          <Form.TextArea
            key={comentario.id}
            id={`textAreaComment-${comentario.id}`}
            name="comentario"
            label={`${comentario.user.nome} - ${format(new Date(comentario.createdAt), 'dd/MM/yyyy HH:mm:ss')}`}
            placeholder="detalhes da chamada..."
            value={comentario.comentario || ''}
            readOnly
          />
        )
      })}
    </Message>
  )
}
